export default __webpack_public_path__ + "static/media/Ketogenic.6fba4ba3.png";